export const showNewPaperImage = (paperImageTileRedesignVariation?: string): boolean =>
  paperImageTileRedesignVariation === 'TEST-1' || paperImageTileRedesignVariation === 'TEST-3';

export const showNewPaperCarousel = (paperImageTileRedesignVariation?: string): boolean =>
  paperImageTileRedesignVariation === 'TEST-2' || paperImageTileRedesignVariation === 'TEST-3';

export const showNewPaperImageOrCarousel = (paperImageTileRedesignVariation?: string): boolean =>
  showNewPaperImage(paperImageTileRedesignVariation) ||
  showNewPaperCarousel(paperImageTileRedesignVariation);
